import { render, staticRenderFns } from "./FeedbackItem.vue?vue&type=template&id=0e34b115&scoped=true&"
import script from "./FeedbackItem.vue?vue&type=script&lang=js&"
export * from "./FeedbackItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackItem.vue?vue&type=style&index=0&id=0e34b115&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34b115",
  null
  
)

export default component.exports